module.exports = __webpack_public_path__ + "img/hyundaiPower.dbeba669.png";